import React from "react";
import { IconType } from "./type";

const IconPlus = ({ width = 17, height = 17, fill = "#424244" }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28 1.04997V7.17997H15.37C15.6591 7.17997 15.9363 7.29481 16.1407 7.49923C16.3452 7.70364 16.46 7.98089 16.46 8.26998C16.46 8.55906 16.3452 8.83631 16.1407 9.04072C15.9363 9.24514 15.6591 9.35997 15.37 9.35997H9.28V15.48C9.2829 15.7517 9.18031 16.014 8.99382 16.2117C8.80733 16.4094 8.55146 16.5271 8.28 16.54V16.54C8.14127 16.54 8.00391 16.5125 7.87586 16.4591C7.74781 16.4057 7.63161 16.3275 7.53398 16.2289C7.43635 16.1303 7.35921 16.0134 7.30704 15.8849C7.25486 15.7563 7.22868 15.6187 7.23 15.48V9.35997H1.09C0.800914 9.35997 0.523668 9.24514 0.319254 9.04072C0.114839 8.83631 0 8.55906 0 8.26998H0C0 7.98089 0.114839 7.70364 0.319254 7.49923C0.523668 7.29481 0.800914 7.17997 1.09 7.17997H7.18V1.04997C7.17282 0.910192 7.19506 0.770458 7.24528 0.639813C7.29551 0.509168 7.3726 0.390522 7.47158 0.291551C7.57055 0.192579 7.68919 0.115486 7.81984 0.0652597C7.95048 0.0150334 8.09022 -0.00720787 8.23 -2.50877e-05V-2.50877e-05C8.36978 -0.00720787 8.50952 0.0150334 8.64016 0.0652597C8.77081 0.115486 8.88945 0.192579 8.98842 0.291551C9.0874 0.390522 9.16449 0.509168 9.21472 0.639813C9.26494 0.770458 9.28718 0.910192 9.28 1.04997V1.04997Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconPlus;
